import { addItem } from '@theme/mr-cart-add';

/**
 * «Completa el mate»: añade el producto sugerido sin salir de la ficha.
 *
 * Entra al carrito solo, sin esperar al mate, que es lo que hace el diseño: el
 * cliente pulsa y lo ve confirmado al momento. El alta va por el ayudante
 * compartido, así el cajón y el contador del header se refrescan igual que con
 * cualquier otra alta del tema.
 */
class MrUpsell extends HTMLElement {
  #controller = new AbortController();
  #busy = false;

  connectedCallback() {
    this.addEventListener('click', this.#handleClick, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #handleClick = async (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('[data-mr-upsell-add]')) return;
    if (this.#busy) return;

    const button = this.querySelector('[data-mr-upsell-add]');
    const label = this.querySelector('[data-mr-upsell-label]');
    const id = this.dataset.variantId;
    if (!(button instanceof HTMLButtonElement) || !label || !id) return;

    this.#busy = true;
    button.disabled = true;

    try {
      await addItem({ id, quantity: 1, source: 'mr-upsell' });
      label.textContent = this.dataset.addedLabel ?? '';
      this.dataset.added = 'true';
    } catch {
      label.textContent = this.dataset.errorLabel ?? '';
      button.disabled = false;
    } finally {
      this.#busy = false;
    }
  };
}

if (!customElements.get('mr-upsell')) {
  customElements.define('mr-upsell', MrUpsell);
}

/*
 * «Sumale a tu pedido» en el carrito lateral se puede plegar. En móvil arranca
 * plegado (lo decide el CSS); en cuanto el cliente lo abre o lo cierra, manda
 * su elección. El cajón se vuelve a pintar con cada cambio del carrito, así
 * que el estado vive en <html> (que no se repinta) y en sessionStorage.
 */
const STATE_KEY = 'mr-cart-upsell-state';
const root = document.documentElement;

try {
  const saved = sessionStorage.getItem(STATE_KEY);
  if (saved === 'open' || saved === 'closed') root.dataset.mrUpsellState = saved;
} catch {
  /* sin almacenamiento: estado por defecto */
}

document.addEventListener('click', (event) => {
  const toggle = event.target instanceof Element ? event.target.closest('[data-mr-cart-upsell-toggle]') : null;
  if (!toggle) return;

  const list = toggle.closest('.mr-cart-upsell')?.querySelector('.mr-cart-upsell__list');
  const isOpen = list instanceof HTMLElement ? getComputedStyle(list).display !== 'none' : true;
  const next = isOpen ? 'closed' : 'open';

  root.dataset.mrUpsellState = next;
  toggle.setAttribute('aria-expanded', String(next === 'open'));

  try {
    sessionStorage.setItem(STATE_KEY, next);
  } catch {
    /* sin almacenamiento: solo dura hasta recargar */
  }
});
